var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 38.4C5.01441 38.4 0 33.3856 0 27.2C0 21.4132 4.38868 16.6514 10.0192 16.0615C9.74568 15.0202 9.6 13.9271 9.6 12.8C9.6 5.73076 15.3308 0 22.4 0C28.4123 0 33.4564 4.14521 34.8304 9.73359C35.4743 9.6455 36.1318 9.6 36.8 9.6C44.7529 9.6 51.2 16.0471 51.2 24C51.2 31.9529 44.7529 38.4 36.8 38.4H28.8V26.9255L32.9373 31.0627C34.1869 32.3124 36.2131 32.3124 37.4627 31.0627C38.7124 29.8131 38.7124 27.7869 37.4627 26.5373L27.8627 16.9373C26.6131 15.6876 24.5869 15.6876 23.3373 16.9373L13.7373 26.5373C12.4876 27.7869 12.4876 29.8131 13.7373 31.0627C14.9869 32.3124 17.0131 32.3124 18.2627 31.0627L22.4 26.9255L22.4 38.4H11.2Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 38.4H28.8L28.8 54.4C28.8 56.1673 27.3673 57.6 25.6 57.6C23.8327 57.6 22.4 56.1673 22.4 54.4L22.4 38.4Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud-icon.7149e33b734b82c612dffdfe5adf1852.svg";
export { ForwardRef as ReactComponent };